import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=1b74c6e0"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=1b74c6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports